export const WHITE_LIST_APP_ADD_REQUEST = 'WHITE_LIST_APP_ADD_REQUEST';
export const WHITE_LIST_APP_REMOVE_REQUEST = 'WHITE_LIST_APP_REMOVE_REQUEST';
export const WHITE_LIST_APP_INFO_REQUEST = 'WHITE_LIST_APP_INFO_REQUEST';
export const SEARCH_APP_INFO_REQUEST = 'SEARCH_APP_INFO_REQUEST';
